import React, { useRef, useState } from "react";
import NovoEventoService from "../../services/Eventos/NovoEventoService";
import { isFaixaEtaria60Mais } from "../../utils/loteUtils";
import { Button, Input, Select, Switch, Toast, Alert, Spinner } from "../ui";
import { 
    Calendar, 
    Clock, 
    MapPin, 
    Flag, 
    Users, 
    DollarSign, 
    Edit3, 
    Plus, 
    Trash2, 
    Image, 
    FileText, 
    X, 
    ArrowRight, 
    Info, 
    CheckCircle2, 
    Award,
    Tag,
    Ticket,
    Map,
    HelpCircle
} from "lucide-react";

function NovoEvento() {
    const [nome_corrida, setNome] = useState("");
    const [data_evento, setDataEvento] = useState("");
    const [hora_inicio, setHoraInicio] = useState("");
    const [inicio_inscricao, setInicioInscricao] = useState("");
    const [fim_inscricao, setFimInscricao] = useState("");
    const [dt_entrega_kit, setDtEntregaKit] = useState("");
    const status = "Em Preparação";
    const [cidade, setCidade] = useState("");
    const [uf, setUF] = useState("");
    const [tamanho_percurso, setTamanhoPercurso] = useState("");
    const [trajeto, setTrajeto] = useState("");
    const [nome_categoria, setNome_categoria] = useState("");
    const [faixa_etaria, setFaixa_etaria] = useState("");
    const [arquivo, setArquivo] = useState(null);
    const [regulamento, setRegulamento] = useState(null);
    const [arquivoTrajeto, setArquivoTrajeto] = useState(null);
    const [qtd_vagas, setQTDVagas] = useState("");

    const [showButton, setShowButton] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [categorias, setCategorias] = useState([]);

    const [cadastrarLotes, setCadastrarLotes] = useState(false);
    const [isGratuita, setIsGratuita] = useState(false);
    const [lotes, setLotes] = useState([]);
    const [nomeLote, setNomeLote] = useState("");
    const [valorLote, setValorLote] = useState("");
    const [dataInicioLote, setDataInicioLote] = useState("");
    const [dataFimLote, setDataFimLote] = useState("");
    const [qtdVagasLote, setQtdVagasLote] = useState("");

    const toast = useRef(null);
    const bannerInputRef = useRef(null);
    const regulamentoInputRef = useRef(null);
    const trajetoInputRef = useRef(null);

    const eventoService = new NovoEventoService();

    const UFs = [
        {"sigla": "AC"}, {"sigla": "AL"}, {"sigla": "AP"}, {"sigla": "AM"},
        {"sigla": "BA"}, {"sigla": "CE"}, {"sigla": "DF"}, {"sigla": "ES"},
        {"sigla": "GO"}, {"sigla": "MA"}, {"sigla": "MT"}, {"sigla": "MS"},
        {"sigla": "MG"}, {"sigla": "PA"}, {"sigla": "PB"}, {"sigla": "PR"},
        {"sigla": "PE"}, {"sigla": "PI"}, {"sigla": "RJ"}, {"sigla": "RN"},
        {"sigla": "RS"}, {"sigla": "RO"}, {"sigla": "RR"}, {"sigla": "SC"},
        {"sigla": "SP"}, {"sigla": "SE"}, {"sigla": "TO"}
    ];

    function AdicionaCategorias(e) {
        if (e) e.preventDefault();
        if (!nome_categoria || !nome_categoria.trim() || !faixa_etaria || !faixa_etaria.trim()) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Preencha a categoria e a faixa etária', life: 3000 });
            return;
        }
        setCategorias(prevData => [...prevData, { 'categoria': nome_categoria.trim(), 'faixa_etaria': faixa_etaria.trim() }]);
        setNome_categoria("");
        setFaixa_etaria("");
    }

    function removeCategoria(index) {
        setCategorias(prevData => prevData.filter((_, i) => i !== index));
    }

    function AdicionaLote(e) {
        if (e) e.preventDefault();
        if (!nomeLote || !nomeLote.trim()) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Informe o nome do lote.', life: 3000 });
            return;
        }
        const numValor = parseFloat(String(valorLote).replace(',', '.'));
        if (isNaN(numValor) || numValor < 0) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Informe um valor válido para o lote.', life: 3000 });
            return;
        }
        if (!dataInicioLote || !dataFimLote) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Preencha as datas de início e fim do lote.', life: 3000 });
            return;
        }
        if (dataInicioLote > dataFimLote) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'A data de início não pode ser posterior à data de fim.', life: 3000 });
            return;
        }

        const novoLote = {
            nome_lote: nomeLote.trim(),
            valor: numValor,
            data_inicio: dataInicioLote,
            data_fim: dataFimLote,
            qtd_vagas: parseInt(qtdVagasLote) || 0,
            ordem: lotes.length + 1
        };

        setLotes(prevData => [...prevData, novoLote]);
        setNomeLote("");
        setValorLote("");
        setDataInicioLote("");
        setDataFimLote("");
        setQtdVagasLote("");
    }

    function removeLote(index) {
        setLotes(prevData => prevData.filter((_, i) => i !== index).map((item, idx) => ({ ...item, ordem: idx + 1 })));
    }

    function getStatusLote(dataInicio, dataFim) {
        if (!dataInicio || !dataFim) return { label: 'Indefinido', badgeVariant: 'secondary' };
        const now = new Date().toISOString().split('T')[0];

        if (now < dataInicio) {
            return { label: 'Agendado', badgeVariant: 'warning' };
        } else if (now > dataFim) {
            return { label: 'Encerrado', badgeVariant: 'secondary' };
        } else {
            return { label: 'Ativo', badgeVariant: 'success' };
        }
    }

    function formataDataVisual(dataIso) {
        if (!dataIso) return '-';
        const parts = String(dataIso).split('T')[0].split('-');
        if (parts.length === 3) {
            return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        return dataIso;
    }

    async function handleAdicionaLotes(eventoId) {
        for (const lote of lotes) {
            const lotePayload = {
                id_corrida: parseInt(eventoId),
                nome_lote: lote.nome_lote,
                valor: typeof lote.valor === 'number' ? lote.valor.toFixed(2) : String(lote.valor),
                data_inicio: lote.data_inicio,
                data_fim: lote.data_fim,
                qtd_vagas: parseInt(lote.qtd_vagas) || 0,
                ordem: lote.ordem
            };
            try {
                await eventoService.setNovoLote(lotePayload);
            } catch (error) {
                console.error("Erro ao cadastrar lote:", error);
            }
        }
    }

    function handleTrajetoFileSelect(e) {
        const file = e.target.files?.[0];
        if (!file) return;

        const ext = file.name.split('.').pop()?.toLowerCase();
        if (!['kml', 'kmz', 'gpx'].includes(ext || '')) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Formato Inválido',
                detail: 'Por favor, selecione um arquivo válido (.kml, .kmz ou .gpx).',
                life: 4000
            });
            if (trajetoInputRef.current) trajetoInputRef.current.value = "";
            return;
        }

        const maxBytes = 5 * 1024 * 1024;
        if (file.size > maxBytes) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Arquivo Muito Grande',
                detail: 'O arquivo de trajeto excede o limite máximo permitido de 5 MB.',
                life: 4000
            });
            if (trajetoInputRef.current) trajetoInputRef.current.value = "";
            return;
        }

        setArquivoTrajeto(file);
    }

    async function handleUploadTrajetoCorrida(eventoId) {
        try {
            if (arquivoTrajeto) {
                const formData = new FormData();
                formData.append('arquivo', arquivoTrajeto);
                const res = await eventoService.uploadTrajeto(eventoId, formData);
                if (!res.ok) {
                    const errData = await res.json().catch(() => null);
                    console.warn("Aviso ao processar trajeto:", errData?.erro);
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Trajeto do Mapa',
                        detail: errData?.erro || 'Evento criado, mas houve um problema ao processar o arquivo de trajeto.',
                        life: 5000
                    });
                }
            }
        } catch (error) {
            console.error("Erro ao enviar trajeto do Google Maps:", error);
        } finally {
            setShowMessage(true);
            setShowLoader(false);
            toast.current?.show({ severity: 'success', summary: 'Sucesso', detail: `${nome_corrida || 'Evento'} registrado com sucesso!`, life: 4000 });
        }
    }

    async function handleUploadRegulamentoCorrida(eventoId) {
        try {
            if (regulamento) {
                const formData = new FormData();
                formData.append('id_corrida', eventoId);
                formData.append('regulamento', regulamento);
                await eventoService.setRegulamentoCorrida(formData);
            }
            await handleUploadTrajetoCorrida(eventoId);
        } catch (error) {
            console.error(error);
            await handleUploadTrajetoCorrida(eventoId);
        }
    }

    async function handleUploadFolderCorrida(eventoId) {
        try {
            if (arquivo) {
                const formData = new FormData();
                formData.append('id_corrida', eventoId);
                formData.append('folder', arquivo);
                await eventoService.setFolderCorrida(formData, eventoId);
            }
            await handleUploadRegulamentoCorrida(eventoId);
        } catch (error) {
            console.error(error);
            await handleUploadRegulamentoCorrida(eventoId);
        }
    }

    async function handleAdicionaCategorias(eventoId) {
        if (!categorias || categorias.length === 0) {
            await handleUploadFolderCorrida(eventoId);
            return;
        }

        const newData = categorias.map(item => ({
            ...item,
            id_corrida: parseInt(eventoId)
        }));

        try {
            const response = await eventoService.setCategoriasEvento(JSON.stringify(newData));
            if (response && (response.status === 201 || response.status === 200)) {
                await handleUploadFolderCorrida(eventoId);
            } else {
                await handleUploadFolderCorrida(eventoId);
            }
        } catch (error) {
            console.error("Erro ao adicionar categorias:", error);
            await handleUploadFolderCorrida(eventoId);
        }
    }

    async function handleSubmit(e) {
        if (e) e.preventDefault();

        if (!nome_corrida || !nome_corrida.trim()) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Informe o nome do evento.', life: 4000 });
            return;
        }

        if (!data_evento) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Informe a data do evento.', life: 4000 });
            return;
        }

        if (!isGratuita && cadastrarLotes && lotes.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Lotes Obrigatórios',
                detail: 'Você ativou a configuração de lotes. Adicione pelo menos um lote ou desative a opção.',
                life: 4000
            });
            return;
        }

        const data = {
            'id_usuario': parseInt(sessionStorage.getItem('brv-user-id')),
            'nome_corrida': nome_corrida.trim(),
            'data_evento': data_evento,
            'hora_inicio_evento': hora_inicio ? (hora_inicio.length === 5 ? `${hora_inicio}:00` : hora_inicio) : null,
            'inicio_inscricao': inicio_inscricao || null,
            'fim_inscricao': fim_inscricao || null,
            'dt_entrega_kit': dt_entrega_kit || null,
            'status_evento': status,
            'is_gratuita': isGratuita,
            'valor_inscricao': isGratuita ? 0 : null,
            'cidade_evento': cidade.trim() || null,
            'uf': typeof uf === 'object' && uf ? uf.sigla : uf || null,
            'tamanho_percurso': tamanho_percurso || null,
            'trajeto': trajeto || null,
            'qtd_vagas': qtd_vagas ? parseInt(qtd_vagas) : null
        };

        try {
            setShowButton(false);
            setShowLoader(true);

            const response = await eventoService.setNovoEvento(JSON.stringify(data));
            let responseData = {};
            try {
                responseData = await response.json();
            } catch (_) {}

            if (response.status === 201) {
                if (!isGratuita && cadastrarLotes && lotes.length > 0) {
                    await handleAdicionaLotes(responseData.id);
                }
                await handleAdicionaCategorias(responseData.id);
            } else {
                setShowLoader(false);
                setShowButton(true);
                const errorMsg = responseData?.detail || responseData?.error || 'Erro ao criar evento. Verifique os dados preenchidos.';
                toast.current?.show({ severity: 'error', summary: 'Erro', detail: errorMsg, life: 5000 });
            }
        } catch (err) {
            console.error("Erro na criação do evento:", err);
            setShowLoader(false);
            setShowButton(true);
            toast.current?.show({ severity: 'error', summary: 'Erro de Conexão', detail: 'Não foi possível comunicar com o servidor.', life: 5000 });
        }
    }

    return (
        <div className="w-full">
            <Toast ref={toast} />

            {/* Cabeçalho da Página */}
            <div className="mb-6">
                <h1 className="text-2xl sm:text-3xl font-extrabold text-white uppercase tracking-wide">Novo Evento</h1>
                <p className="text-slate-400 text-sm mt-1">Preencha os dados abaixo para cadastrar o seu evento esportivo.</p>
            </div>

            {/* Card Principal */}
            <div className="bg-urb-card border border-urb-border rounded-2xl p-6 sm:p-8 shadow-xl flex flex-col gap-8">
                
                {/* 1. DADOS DO EVENTO */}
                <div>
                    <div className="flex items-center justify-between pb-3 border-b border-urb-border mb-6">
                        <span className="font-extrabold text-sm sm:text-base text-white uppercase tracking-wider flex items-center gap-2">
                            <Flag className="w-4 h-4 text-urb-primary" />
                            Dados do Evento
                        </span>
                        <div className="flex items-center gap-3">
                            <label
                                htmlFor="toggle-gratuita"
                                onClick={() => {
                                    const next = !isGratuita;
                                    setIsGratuita(next);
                                    if (next) setCadastrarLotes(false);
                                }}
                                className={`text-xs font-semibold cursor-pointer select-none transition-colors ${isGratuita ? 'text-urb-primary' : 'text-slate-400'}`}
                            >
                                {isGratuita ? 'Evento Gratuito Ativado' : 'Evento Gratuito'}
                            </label>
                            <Switch
                                id="toggle-gratuita"
                                checked={isGratuita}
                                onChange={(val) => {
                                    const nextChecked = typeof val === "boolean" ? val : (val?.value !== undefined ? val.value : !isGratuita);
                                    setIsGratuita(nextChecked);
                                    if (nextChecked) {
                                        setCadastrarLotes(false);
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
                        {/* Linha 1 */}
                        <div className="md:col-span-5">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Edit3 className="w-3.5 h-3.5 text-urb-primary" />
                                Nome do Evento <span className="text-red-400">*</span>
                            </label>
                            <Input
                                id="nome-corrida"
                                value={nome_corrida}
                                onChange={(e) => setNome(e.target.value)}
                                placeholder="Digite o nome do evento"
                            />
                        </div>

                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Calendar className="w-3.5 h-3.5 text-urb-primary" />
                                Data do Evento <span className="text-red-400">*</span>
                            </label>
                            <Input
                                id="data_evento"
                                type="date"
                                value={data_evento}
                                onChange={(e) => setDataEvento(e.target.value)}
                            />
                        </div>

                        <div className="md:col-span-3">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Clock className="w-3.5 h-3.5 text-urb-primary" />
                                Hora de Início
                            </label>
                            <Input
                                id="hora_inicio"
                                type="time"
                                value={hora_inicio}
                                onChange={(e) => setHoraInicio(e.target.value)}
                            />
                        </div>

                        {/* Linha 2 */}
                        <div className="md:col-span-5">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <MapPin className="w-3.5 h-3.5 text-urb-primary" />
                                Cidade
                            </label>
                            <Input
                                id="cidade"
                                value={cidade}
                                onChange={(e) => setCidade(e.target.value)}
                                placeholder="Digite a cidade do evento"
                            />
                        </div>

                        <div className="md:col-span-3">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <MapPin className="w-3.5 h-3.5 text-urb-primary" />
                                Estado (UF)
                            </label>
                            <Select
                                id="uf"
                                value={uf}
                                onChange={(e) => setUF(e.value)}
                                options={UFs}
                                optionLabel="sigla"
                                placeholder="Selecione a UF"
                            />
                        </div>

                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Flag className="w-3.5 h-3.5 text-urb-primary" />
                                Distância / Percurso (KM)
                            </label>
                            <Input
                                id="tamanho_percurso"
                                type="number"
                                step="0.1"
                                min="0"
                                value={tamanho_percurso}
                                onChange={(e) => setTamanhoPercurso(e.target.value)}
                                placeholder="Ex.: 5, 10, 21"
                            />
                        </div>

                        {/* Linha 3 */}
                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Users className="w-3.5 h-3.5 text-urb-primary" />
                                Quantidade de Vagas
                            </label>
                            <Input
                                id="qtd_vagas"
                                type="number"
                                min="0"
                                value={qtd_vagas}
                                onChange={(e) => setQTDVagas(e.target.value)}
                                placeholder="Ex.: 500"
                            />
                        </div>

                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <DollarSign className="w-3.5 h-3.5 text-urb-primary" />
                                Valor da Inscrição
                            </label>
                            <Input
                                id="valor"
                                value={isGratuita ? "Gratuito (R$ 0,00)" : (cadastrarLotes ? "Definido por Lotes" : "Sem Lotes (Configurar Depois)")}
                                disabled
                                className={isGratuita ? "!text-urb-primary font-bold bg-urb-primary/10" : "opacity-75"}
                            />
                        </div>

                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Calendar className="w-3.5 h-3.5 text-urb-primary" />
                                Início das Inscrições
                            </label>
                            <Input
                                id="inicio_inscricao"
                                type="date"
                                value={inicio_inscricao}
                                onChange={(e) => setInicioInscricao(e.target.value)}
                            />
                        </div>

                        {/* Linha 4 */}
                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Calendar className="w-3.5 h-3.5 text-urb-primary" />
                                Fim das Inscrições
                            </label>
                            <Input
                                id="fim_inscricao"
                                type="date"
                                value={fim_inscricao}
                                onChange={(e) => setFimInscricao(e.target.value)}
                            />
                        </div>

                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <Calendar className="w-3.5 h-3.5 text-urb-primary" />
                                Data de Entrega do Kit
                            </label>
                            <Input
                                id="dt_entrega_kit"
                                type="date"
                                value={dt_entrega_kit}
                                onChange={(e) => setDtEntregaKit(e.target.value)}
                            />
                        </div>

                        <div className="md:col-span-4">
                            <label className="text-xs font-semibold text-slate-300 mb-1.5 flex items-center gap-1.5">
                                <FileText className="w-3.5 h-3.5 text-urb-primary" />
                                Trajeto / Observações rápidas
                            </label>
                            <Input
                                id="trajeto"
                                value={trajeto}
                                onChange={(e) => setTrajeto(e.target.value)}
                                placeholder="Informações úteis sobre percurso, hidratação, etc."
                            />
                        </div>
                    </div>
                </div>

                {/* 2. LOTES DE INSCRIÇÃO */}
                <div>
                    <div className="flex items-center justify-between pb-3 border-b border-urb-border mb-6">
                        <div className="flex items-center gap-2">
                            <span className="font-extrabold text-sm sm:text-base text-white uppercase tracking-wider flex items-center gap-2">
                                <Ticket className="w-4 h-4 text-urb-primary" />
                                Lotes de Inscrição
                            </span>
                            <Info className="w-4 h-4 text-slate-500" title={isGratuita ? "Eventos gratuitos não utilizam lotes." : "Ative para cadastrar lotes agora."} />
                        </div>
                        {!isGratuita && (
                            <div className="flex items-center gap-3">
                                <label
                                    htmlFor="toggle-lotes"
                                    onClick={() => setCadastrarLotes(!cadastrarLotes)}
                                    className={`text-xs font-semibold cursor-pointer select-none transition-colors ${cadastrarLotes ? 'text-urb-primary' : 'text-slate-400'}`}
                                >
                                    {cadastrarLotes ? 'Definir Lotes Ativado' : 'Definir Lotes Agora'}
                                </label>
                                <Switch
                                    id="toggle-lotes"
                                    checked={cadastrarLotes}
                                    onChange={(val) => {
                                        const nextChecked = typeof val === "boolean" ? val : (val?.value !== undefined ? val.value : !cadastrarLotes);
                                        setCadastrarLotes(nextChecked);
                                    }}
                                />
                            </div>
                        )}
                    </div>

                    {isGratuita ? (
                        <div className="p-4 rounded-xl border border-urb-primary/30 bg-urb-primary/10 flex items-center gap-3 text-urb-primary text-sm">
                            <CheckCircle2 className="w-5 h-5 shrink-0" />
                            <span>
                                <strong>Evento Gratuito:</strong> A cobrança e os lotes de inscrição foram desativados para esta corrida. Os atletas poderão se inscrever gratuitamente sem gerar cobrança.
                            </span>
                        </div>
                    ) : !cadastrarLotes ? (
                        <div className="p-4 rounded-xl border border-urb-border bg-slate-900/60 text-slate-400 text-sm flex items-center gap-3">
                            <Info className="w-5 h-5 shrink-0 text-slate-500" />
                            <span>O cadastro de lotes está desativado. Você pode cadastrar a corrida agora e definir os lotes posteriormente.</span>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 items-end p-4 rounded-xl bg-slate-900/70 border border-urb-border">
                                <div className="lg:col-span-3">
                                    <label className="text-xs font-semibold text-slate-300 mb-1 block">Nome do Lote</label>
                                    <Input
                                        value={nomeLote}
                                        onChange={(e) => setNomeLote(e.target.value)}
                                        placeholder="Ex.: 1º Lote ou Promocional"
                                    />
                                </div>

                                <div className="lg:col-span-2">
                                    <label className="text-xs font-semibold text-slate-300 mb-1 block">Valor (R$)</label>
                                    <Input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={valorLote}
                                        onChange={(e) => setValorLote(e.target.value)}
                                        placeholder="Ex.: 75.00"
                                    />
                                </div>

                                <div className="lg:col-span-2">
                                    <label className="text-xs font-semibold text-slate-300 mb-1 block">Início do Lote</label>
                                    <Input
                                        type="date"
                                        value={dataInicioLote}
                                        onChange={(e) => setDataInicioLote(e.target.value)}
                                    />
                                </div>

                                <div className="lg:col-span-2">
                                    <label className="text-xs font-semibold text-slate-300 mb-1 block">Fim do Lote</label>
                                    <Input
                                        type="date"
                                        value={dataFimLote}
                                        onChange={(e) => setDataFimLote(e.target.value)}
                                    />
                                </div>

                                <div className="lg:col-span-2">
                                    <label className="text-xs font-semibold text-slate-300 mb-1 block">Vagas</label>
                                    <Input
                                        type="number"
                                        min="0"
                                        value={qtdVagasLote}
                                        onChange={(e) => setQtdVagasLote(e.target.value)}
                                        placeholder="0 = Ilimitado"
                                    />
                                </div>

                                <div className="lg:col-span-1">
                                    <Button
                                        type="button"
                                        onClick={AdicionaLote}
                                        className="w-full flex items-center justify-center py-2.5 shadow-neon"
                                        title="Adicionar Lote"
                                    >
                                        <Plus className="w-5 h-5" />
                                    </Button>
                                </div>
                            </div>

                            {/* Tabela de Lotes Adicionados */}
                            {lotes.length === 0 ? (
                                <div className="p-4 rounded-xl border border-urb-border bg-slate-900/40 text-center text-slate-400 text-sm">
                                    Nenhum lote adicionado ainda. Adicione pelo menos um lote de inscrição.
                                </div>
                            ) : (
                                <div className="border border-urb-border rounded-xl overflow-hidden shadow-md">
                                    <table className="w-full text-left text-xs sm:text-sm">
                                        <thead className="bg-slate-900/90 text-slate-400 uppercase font-semibold text-[11px] tracking-wider border-b border-urb-border">
                                            <tr>
                                                <th className="p-3">#</th>
                                                <th className="p-3">Nome do Lote</th>
                                                <th className="p-3">Valor</th>
                                                <th className="p-3">Período</th>
                                                <th className="p-3">Vagas</th>
                                                <th className="p-3">Status</th>
                                                <th className="p-3 text-center">Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-urb-border bg-urb-card">
                                            {lotes.map((lote, idx) => {
                                                const statusLote = getStatusLote(lote.data_inicio, lote.data_fim);
                                                return (
                                                    <tr key={idx} className="hover:bg-slate-900/30 transition-colors">
                                                        <td className="p-3 font-semibold text-white">{lote.ordem || idx + 1}</td>
                                                        <td className="p-3 font-semibold text-white">{lote.nome_lote}</td>
                                                        <td className="p-3 font-bold text-urb-primary">
                                                            {Number(lote.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                        </td>
                                                        <td className="p-3 text-slate-300">
                                                            {formataDataVisual(lote.data_inicio)} até {formataDataVisual(lote.data_fim)}
                                                        </td>
                                                        <td className="p-3 text-slate-300">
                                                            {lote.qtd_vagas && lote.qtd_vagas > 0 ? `${lote.qtd_vagas} vagas` : 'Ilimitado'}
                                                        </td>
                                                        <td className="p-3">
                                                            <span className={`px-2 py-0.5 rounded text-[11px] font-bold uppercase tracking-wider ${
                                                                statusLote.label === 'Ativo' 
                                                                    ? 'bg-urb-primary/20 text-urb-primary' 
                                                                    : statusLote.label === 'Agendado' 
                                                                        ? 'bg-amber-500/20 text-amber-400' 
                                                                        : 'bg-slate-800 text-slate-400'
                                                            }`}>
                                                                {statusLote.label}
                                                            </span>
                                                        </td>
                                                        <td className="p-3 text-center">
                                                            <button
                                                                type="button"
                                                                onClick={() => removeLote(idx)}
                                                                title="Remover Lote"
                                                                className="text-red-400 hover:text-red-300 p-1.5 rounded-lg hover:bg-red-500/10 transition-colors"
                                                            >
                                                                <Trash2 className="w-4 h-4" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* 3. CATEGORIAS & MÍDIA E REGULAMENTO */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {/* Coluna Esquerda: Categorias */}
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center justify-between pb-3 border-b border-urb-border">
                            <span className="font-extrabold text-sm sm:text-base text-white uppercase tracking-wider flex items-center gap-2">
                                <Award className="w-4 h-4 text-urb-primary" />
                                Categorias
                            </span>
                            <Info className="w-4 h-4 text-slate-500" title="Adicione categorias e faixas etárias para premiação." />
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-12 gap-3 items-end p-4 rounded-xl bg-slate-900/70 border border-urb-border">
                            <div className="sm:col-span-5">
                                <label className="text-xs font-semibold text-slate-300 mb-1 block">Categoria</label>
                                <Input
                                    value={nome_categoria}
                                    onChange={(e) => setNome_categoria(e.target.value)}
                                    placeholder="Ex.: Geral 5K"
                                />
                            </div>
                            <div className="sm:col-span-4">
                                <div className="flex items-center justify-between mb-1">
                                    <label className="text-xs font-semibold text-slate-300 block">Faixa etária</label>
                                    <button
                                        type="button"
                                        onClick={() => setFaixa_etaria("60+")}
                                        className="text-[10px] text-urb-primary hover:underline cursor-pointer"
                                        title="Preencher com 60+ (aplica 50% de desconto automático)"
                                    >
                                        + Usar 60+
                                    </button>
                                </div>
                                <Input
                                    value={faixa_etaria}
                                    onChange={(e) => setFaixa_etaria(e.target.value)}
                                    placeholder="Ex.: 18 a 29 anos, 60+, Livre"
                                />
                                <span className="text-[10px] text-slate-400 mt-0.5 block">
                                    Faixas como <strong className="text-slate-300">60+</strong> recebem 50% de desconto automático.
                                </span>
                            </div>
                            <div className="sm:col-span-3">
                                <Button
                                    type="button"
                                    onClick={AdicionaCategorias}
                                    className="w-full flex items-center justify-center gap-1.5 py-2.5 font-bold shadow-neon text-xs"
                                >
                                    <Plus className="w-4 h-4" /> Adicionar
                                </Button>
                            </div>
                        </div>

                        {/* Lista de Categorias Adicionadas */}
                        <div className="p-3 rounded-xl border border-urb-border bg-slate-900/40">
                            {categorias.length === 0 ? (
                                <div className="text-center py-6 text-slate-400 text-xs">
                                    Nenhuma categoria adicionada ainda.
                                </div>
                            ) : (
                                <div className="flex flex-col gap-2 max-h-48 overflow-y-auto pr-1">
                                    {categorias.map((cat, idx) => {
                                        const is60 = isFaixaEtaria60Mais(cat.faixa_etaria);
                                        return (
                                            <div key={idx} className="flex items-center justify-between p-2.5 rounded-lg bg-urb-card border border-urb-border text-xs">
                                                <div className="flex items-center gap-2 flex-wrap">
                                                    <Tag className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                                                    <span className="font-semibold text-white">{cat.categoria}</span>
                                                    <span className="text-slate-400">({cat.faixa_etaria})</span>
                                                    {is60 && (
                                                        <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">
                                                            50% OFF 60+
                                                        </span>
                                                    )}
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => removeCategoria(idx)}
                                                    title="Remover Categoria"
                                                    className="text-red-400 hover:text-red-300 p-1 rounded hover:bg-red-500/10 transition-colors"
                                                >
                                                    <Trash2 className="w-3.5 h-3.5" />
                                                </button>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Coluna Direita: Mídia e Regulamento */}
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center justify-between pb-3 border-b border-urb-border">
                            <span className="font-extrabold text-sm sm:text-base text-white uppercase tracking-wider flex items-center gap-2">
                                <Image className="w-4 h-4 text-urb-primary" />
                                Mídia, Regulamento e Trajeto Google Maps
                            </span>
                            <Info className="w-4 h-4 text-slate-500" title="Faça o upload do banner de divulgação, do regulamento oficial e da rota no Google Maps (.kml, .kmz, .gpx)." />
                        </div>

                        <input
                            type="file"
                            ref={bannerInputRef}
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                                if (e.target.files && e.target.files[0]) {
                                    setArquivo(e.target.files[0]);
                                }
                            }}
                        />
                        <input
                            type="file"
                            ref={regulamentoInputRef}
                            accept="application/pdf"
                            className="hidden"
                            onChange={(e) => {
                                if (e.target.files && e.target.files[0]) {
                                    setRegulamento(e.target.files[0]);
                                }
                            }}
                        />
                        <input
                            type="file"
                            ref={trajetoInputRef}
                            accept=".kml,.kmz,.gpx"
                            className="hidden"
                            onChange={handleTrajetoFileSelect}
                        />

                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                            {/* Card Banner */}
                            <div
                                onClick={() => bannerInputRef.current && bannerInputRef.current.click()}
                                className="p-4 rounded-xl border border-dashed border-urb-border bg-slate-900/60 hover:border-urb-primary hover:bg-urb-primary/5 transition-all cursor-pointer flex flex-col items-center justify-center text-center gap-2"
                            >
                                <Image className="w-8 h-8 text-slate-400" />
                                <div>
                                    <span className="font-bold text-xs sm:text-sm text-white block truncate max-w-[160px]">
                                        {arquivo ? arquivo.name : "Selecionar Banner"}
                                    </span>
                                    <span className="text-[11px] text-slate-400 mt-0.5 block">
                                        {arquivo ? `${(arquivo.size / (1024 * 1024)).toFixed(2)} MB` : "Formatos: JPG, PNG • Máx. 5MB"}
                                    </span>
                                </div>
                                {arquivo && (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setArquivo(null);
                                            if (bannerInputRef.current) bannerInputRef.current.value = "";
                                        }}
                                        className="text-red-400 text-xs flex items-center gap-1 hover:text-red-300 mt-1"
                                    >
                                        <X className="w-3.5 h-3.5" /> Remover
                                    </button>
                                )}
                            </div>

                            {/* Card Regulamento */}
                            <div
                                onClick={() => regulamentoInputRef.current && regulamentoInputRef.current.click()}
                                className="p-4 rounded-xl border border-dashed border-urb-border bg-slate-900/60 hover:border-urb-primary hover:bg-urb-primary/5 transition-all cursor-pointer flex flex-col items-center justify-center text-center gap-2"
                            >
                                <FileText className="w-8 h-8 text-slate-400" />
                                <div>
                                    <span className="font-bold text-xs sm:text-sm text-white block truncate max-w-[160px]">
                                        {regulamento ? regulamento.name : "Upload Regulamento"}
                                    </span>
                                    <span className="text-[11px] text-slate-400 mt-0.5 block">
                                        {regulamento ? `${(regulamento.size / (1024 * 1024)).toFixed(2)} MB` : "Formato: PDF • Máx. 10MB"}
                                    </span>
                                </div>
                                {regulamento && (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setRegulamento(null);
                                            if (regulamentoInputRef.current) regulamentoInputRef.current.value = "";
                                        }}
                                        className="text-red-400 text-xs flex items-center gap-1 hover:text-red-300 mt-1"
                                    >
                                        <X className="w-3.5 h-3.5" /> Remover
                                    </button>
                                )}
                            </div>

                            {/* Card Trajeto Google Maps */}
                            <div
                                onClick={() => trajetoInputRef.current && trajetoInputRef.current.click()}
                                className={`p-4 rounded-xl border border-dashed transition-all cursor-pointer flex flex-col items-center justify-center text-center gap-2 ${
                                    arquivoTrajeto
                                        ? 'border-emerald-500/60 bg-emerald-950/20'
                                        : 'border-urb-border bg-slate-900/60 hover:border-urb-primary hover:bg-urb-primary/5'
                                }`}
                            >
                                <Map className={`w-8 h-8 ${arquivoTrajeto ? 'text-emerald-400' : 'text-slate-400'}`} />
                                <div>
                                    <span className="font-bold text-xs sm:text-sm text-white block truncate max-w-[160px]">
                                        {arquivoTrajeto ? arquivoTrajeto.name : "Trajeto Google Maps"}
                                    </span>
                                    <span className="text-[11px] text-slate-400 mt-0.5 block">
                                        {arquivoTrajeto
                                            ? `${(arquivoTrajeto.size / (1024 * 1024)).toFixed(2)} MB • ${(arquivoTrajeto.name.split('.').pop() || '').toUpperCase()}`
                                            : "Formatos: KML, KMZ, GPX • Máx. 5MB"}
                                    </span>
                                </div>
                                {arquivoTrajeto && (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setArquivoTrajeto(null);
                                            if (trajetoInputRef.current) trajetoInputRef.current.value = "";
                                        }}
                                        className="text-red-400 text-xs flex items-center gap-1 hover:text-red-300 mt-1"
                                    >
                                        <X className="w-3.5 h-3.5" /> Remover
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Dica Google My Maps */}
                        <details className="text-xs text-slate-400 bg-slate-900/60 p-3.5 rounded-xl border border-urb-border group">
                            <summary className="cursor-pointer font-semibold text-slate-300 flex items-center gap-2 select-none hover:text-white">
                                <HelpCircle className="w-4 h-4 text-urb-primary" />
                                <span>Como criar e exportar o percurso no Google My Maps?</span>
                            </summary>
                            <ol className="list-decimal list-inside mt-2.5 space-y-1.5 pl-2 text-slate-400 border-t border-urb-border pt-2.5 leading-relaxed">
                                <li>Acesse <a href="https://mymaps.google.com" target="_blank" rel="noreferrer" className="text-urb-primary underline hover:text-emerald-300">mymaps.google.com</a> e crie um novo mapa.</li>
                                <li>Clique no ícone <strong>Adicionar trajeto a pé / em linha</strong> e trace as ruas da corrida.</li>
                                <li>No menu de 3 pontos verticais ao lado do título do mapa, clique em <strong>Exportar para KML/KMZ</strong>.</li>
                                <li>Faça o download do arquivo gerado e envie-o no campo de trajeto acima.</li>
                            </ol>
                        </details>
                    </div>
                </div>

                {/* Mensagens de Feedback */}
                {showMessage && (
                    <Alert variant="success">
                        {(nome_corrida || 'Evento')} registrado com sucesso!
                    </Alert>
                )}

                {showLoader && (
                    <div className="flex justify-center py-4">
                        <Spinner size="lg" />
                    </div>
                )}

                {/* Botão de Ação Inferior */}
                <div className="flex justify-end pt-4 border-t border-urb-border">
                    {showButton && (
                        <Button
                            type="button"
                            onClick={(e) => handleSubmit(e)}
                            className="px-8 py-3.5 font-bold text-base shadow-neon flex items-center gap-2"
                        >
                            <span>Salvar e continuar</span>
                            <ArrowRight className="w-4 h-4" />
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default NovoEvento;